var _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJqueryMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 800,
    preserveAspectRatio: "xMidYMid",
    viewBox: "0 -32.5 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0481A3",
    d: "M34.337.037h183.452c4.016 0 6.995 3.724 6.114 7.642l-25.856 114.928a8.744 8.744 0 0 1-8.53 6.825H7.006c-4.482 0-7.81-4.15-6.836-8.526L25.515 7.11A9.039 9.039 0 0 1 34.337.037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#14BEF0",
    d: "M114.684 31.33h136.448c3.116 0 5.429 2.889 4.749 5.929L232.954 139.78a7.802 7.802 0 0 1-7.613 6.098H88.478c-2.818 0-4.91-2.612-4.291-5.362L107.4 37.16a7.464 7.464 0 0 1 7.283-5.83"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#73D8F4",
    d: "M114.684 31.33a7.464 7.464 0 0 0-7.283 5.83l-20.725 92.272h102.84a8.742 8.742 0 0 0 8.53-6.824l20.536-91.277H114.684Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#6ABA2F",
    d: "M70.112 65.535h62.454c3.375 0 5.873 3.14 5.114 6.43l-26.184 113.421A7.244 7.244 0 0 1 104.44 191H41.032c-3.042 0-5.299-2.823-4.628-5.79l25.57-113.17a8.344 8.344 0 0 1 8.138-6.505"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B8EC00",
    d: "M84.187 140.517c-.618 2.75 1.474 5.363 4.292 5.363h32.138l3.797-16.448H86.677l-2.49 11.085Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M132.566 65.535h-31.539l-14.35 63.897h37.736l13.267-57.468c.76-3.289-1.738-6.429-5.114-6.429"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#81D958",
    d: "M70.112 65.535a8.344 8.344 0 0 0-8.139 6.505l-12.967 57.392h37.67l14.351-63.897H70.112Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJqueryMobile);
export default __webpack_public_path__ + "static/media/jquery-mobile.9836173ac6082fb9613557eea4550faf.svg";
export { ForwardRef as ReactComponent };